/**
 * @desc inDeliverySendBackCount
 */
const URL = "/rantion-fulfilment";
import http, { updateResponse } from "@/http";
export function request(
  body: defs.fulfilment.InDeliverySendBackCountRequestParamsDto,
  options?: any,
) {
  return updateResponse(
    http(URL + `/Batch/count`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
